/*
 * @Author: Latte
 * @Date: 2021-11-22 14:42:16
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-22 16:28:54
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\permission.js
 */
import request from "@/utils/request";
import config from "@/utils/config";

/**
 * @description: 获取单个权限的详情
 * @param {*} params
 * @return {*}
 */
export function getPermissionDetail(params) {
	return request({
		url: config.API_AUTH + "/auth/v1/permission",
		method: "get",
		params,
	});
}

/**
 * @description: 新增权限
 * @param {*} data
 * @return {*}
 */
export function createPermission(data) {
	return request({
		url: config.API_AUTH + "/auth/v1/permission",
		method: "post",
		data,
	});
}
/**
 * @description: 更新权限(提供完整的实体类)
 * @param {*} data
 * @return {*}
 */
export function updatePermissionCompletely(data) {
	return request({
		url: config.API_AUTH + "/auth/v1/permission",
		method: "put",
		data,
	});
}
/**
 * @description: 删除权限
 * @param {*} params
 * @return {*}
 */
export function removePermission(params) {
	return request({
		url: config.API_AUTH + "/auth/v1/permission",
		method: "delete",
		params,
	});
}
/**
 * @description: 部分地更新权限
 * @param {*} data
 * @return {*}
 */
export function updatePermissionPartially(data) {
	return request({
		url: config.API_AUTH + "/auth/v1/permission",
		method: "patch",
		data,
	});
}
/**
 * @description: 查询指定用户权限列表
 * @param {*} params
 * @return {*}
 */
export function getPermissionByUser(params) {
	return request({
		url: config.API_AUTH + "/auth/v1/permission/user/list",
		method: "get",
		params,
	});
}
/**
 * @description: 获取所有权限列表
 * @param {*}
 * @return {*}
 */
export function getAllPermissionList() {
	return request({
		url: config.API_AUTH + "/auth/v1/permission/all/list",
		method: "get",
	});
}
/**
 * @description: 获取所有的微服务名
 * @param {*}
 * @return {*}
 */
export function getAllServerName() {
	return request({
		url: config.API_AUTH + "/auth/v1/server/list",
		method: "get",
	});
}

/**
 * 查询指定权限及其以下所有权限列表(树形结构)
 * background 是否后台管理权限，不传默认 -1 ，全部 0-前端权限，1-后端权限
 * belongToIndex 所属父节点，不传默认 -1 ，系统根目录
 * @param {Object} data
 */
export function getAllPermissionListWithOption(data) {
	return request({
		url: config.API_AUTH + "/auth/v1/permission/system/all/list",
		method: "get",
		params:data
	})
}

/**
 * 查询用户后台可访问模块集合
 * @param {Object} data
 */
export function getUserBackgroundPermissionList(data){
	return request({
		url: config.API_AUTH + "/auth/v1/permission/user/background/list",
		method: "get"
	})
}